<template>
  <div class="contain">
    <Row>
      <RadioGroup class="radio-g" v-model="params.uid">
        <Radio :label="item.uid" v-for="item in org" :key="item.id">
            <div class="org-logo">
              <img :src="item.logo_path | logo_show">
            </div>
            <span>{{item.short_name}}</span>
        </Radio>
      </RadioGroup>
    </Row>
    <Row>
      <ul class="f-ul">
        <li>
          <div>简介</div>
          <div>{{item_org.description | empty}}</div>
        </li>
        <li>
          <div>成立时间</div>
          <div>{{item_org.setup_time | timeTrans}}</div>
        </li>
        <li>
          <div>地区</div>
          <div>{{item_org.province | pc(item_org.city)}}</div>
        </li>
        <li>
          <div>规模</div>
          <div>{{item_org.employee_id | dealName(meta.employee, 'id', 'employee')}}</div>
        </li>
        <li>
          <div>投资项目</div>
          <ul>
            <li v-for="(item, index) in list">
              <span>{{item.ht_comp_name}}</span>
              <span>{{item.ht_description | empty}}</span>
              <span>{{item.round_id | dealName(meta.round)}}</span>
              <span>{{item.event_time | timeTrans}}</span>
              <span>{{item.amount | amountPrecise(item.unit_id, item.precise, meta.unit)}}</span>
            </li>
            <p v-if="dwtz.length > 10 && dwtz.length != list.length" @click="changePage">加载更多 <i class="iconfont-sm">&#xe648;</i> </p>
          </ul>
        </li>
      </ul>
    </Row>
    <Spin fix v-if="loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { entityDetail } from '@/service'
export default {
  data() {
    return {
      params: {
        uid: '',
        entity_type: 1,
        type: 'dwtz'
      },
      loading: true,
      page: 1,
      dwtz: [],
      list: [], // 投资列表
      item_org: {}
    }
  },
  computed: {
    uid() {
      return this.params.uid
    }
  },
  props: ['org', 'meta'],
  methods: {
    async getList() {
      let res = await entityDetail(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.dwtz = res.dwtz
        this.$set(this.$data, 'list', [...res.dwtz].splice(0, 10 * this.page))
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    changePage(){
      this.page++
      console.log(this.dwtz)
      this.$set(this.$data, 'list', [...this.dwtz].splice(0, 10 * this.page))
    }
  },
  created() {
    this.params.uid = this.org[0].uid
    // this.item_org = this.org[0]
  },
  watch: {
    uid(val) {
      this.item_org = this.org.find(item => item.uid == val)
      this.getList()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.contain
  commonBgColor(#1f2330, #FFFFFF)
  position: relative
  padding: 30px 50px
  .radio-g
    margin-bottom: -20px
    label
      font-size: 18px
      margin-right: 36px
      margin-bottom: 20px
      span
        font-size: 14px
        color: #fff
      >>> .ivu-radio
        &:hover .ivu-radio-inner
          border-color: rgba(250, 122, 80, 1)
        .ivu-radio-inner
          border: 1px solid
          commonBgColor(#1f2330, #FFFFFF)
          commonBorderColor(#7A7F94, #D5D5D5)
          &.ivu-radio-focus
            box-shadow: none
        &.ivu-radio-checked
          .ivu-radio-inner
            background-color: rgba(250, 122, 80, 1)
            border: 1px solid rgba(250, 122, 80, 1)
            &:after
              background-color: #fff
    .org-logo
      width: 48px
      height: 48px
      display: inline-block
      background: #fff
      line-height: 46px
      border: 1px solid #E8E8E8
      border-radius: 4px
      position: relative
      overflow: hidden
      vertical-align: middle
      text-align: center
      margin-left: 6px
      margin-right: 10px
      img
        max-width: 100%
        max-height: 100%
        vertical-align: middle
  .f-ul
    margin-top: 20px
    width: 100%
    border: 1px solid
    commonBorderColor(#40444F, #F3F3F3)
    border-top: 0
    >li
      display: flex
      border-top: 1px solid
      commonBorderColor(#40444F, #F3F3F3)
      div
        padding: 20px 0 20px 20px
        font-size: 14px
        display: flex
        align-items: center
      div:nth-child(1)
        commonColor(#BCBDC1, #666666)
        commonBgColor(#2A2F42, #FFFAF5)
        width: 120px
      div:nth-child(2)
        flex: 2
        commonColor(#e9e9eb, #333333)
        line-height: 22px
      ul
        flex: 2
        commonColor(#e9e9eb, #333333)
        font-size: 14px
        li
          padding: 20px 0 20px 20px
          span+span
            position: relative
            margin-left: 21px
            &:before
              content: ''
              position: absolute
              commonBgColor(#40444f, #D9D9D9)
              width: 1px
              height: 12px
              top: 2px
              left: -11px
        li+li
          border-top: 1px solid
          commonBorderColor(#40444F, #F3F3F3)
        p
          color: rgba(250, 122, 80, 1)
          text-align: center
          padding: 20px
          cursor: pointer
          &:hover
            color: #FC9C7C
</style>
